export default function() {

  let widgetName;
  let widgetOpts;
  
  if (window.siteTheme === 'Amphitheater') {
    widgetName = 'cardWidgetAmpSEO';
    widgetOpts = cardWidgetAmpSEOOpts;
  }
  if (window.siteTheme === 'Oncenter') {
    widgetName = 'cardWidgetOncSEO';
    widgetOpts = cardWidgetOncSEOOpts;
  }  

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function(data, owl, hasData) {
      const widget = $(`#${widgetName}`);
      widget.show();
      if (widgetName === 'cardWidgetOncSEO') {
        widget.append(`
          <div class="seo-arrows">
            <div class="seo-arrows__b"></div>
            <div class="seo-arrows__g"></div>
            <div class="seo-arrows__y"></div>
          </div>
        `);
      }
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: {
      visible: false,
      text: 'MORE'
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: true,
    slideshow: false, // for documentation on Owl Slider: https://owlcarousel2.github.io/OwlCarousel2/docs/started-welcome.html
    slideshowOptions: {
      items: 1,
      loop: true,
      margin: 10,
      navText: ['Prev','Next'],
      nav: true
    },
    textOverImage: false
  });

}